import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Button from "./ui/Button";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { RoleGate } from "./middleware/RoleGate.jsx";


const mesesDelAnio = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const getTipo = (tiposSocio, id) => {
  if (!Array.isArray(tiposSocio)) return "Desconocido";
  const tipo = tiposSocio.find(t => Number(t.id) === Number(id));
  return tipo ? tipo.nombre : "Desconocido";
};

const Contabilidad = () => {
  const [socios, setSocios] = useState([]);
  const [tiposSocio, setTiposSocio] = useState([]);
  const [pagos, setPagos] = useState({});
  const [selectedSocio, setSelectedSocio] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalMontos, setShowModalMontos] = useState(false);
  const [showModalCI, setShowModalCI] = useState(false);
  const [montosPorTipo, setMontosPorTipo] = useState({});
  const [montosEspeciales, setMontosEspeciales] = useState({});
  const [busqueda, setBusqueda] = useState("");
  const [tipoFiltro, setTipoFiltro] = useState("todos");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [Internacional, setInternacional] = useState(false);
  const [ciRut, setCiRut] = useState("");
  const [familiaFiltro, setFamiliaFiltro] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFiltro, setStatusFiltro] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "n_socio", direction: "asc" });


  useEffect(() => {
    fetchTiposSocio();
    fetchMontos();
    fetchMontosEspeciales();
  }, []);

  useEffect(() => {
    if (tiposSocio.length > 0) {
      fetchSocios();
    }
  }, [tiposSocio]);

  const fetchSocios = async () => {
    try {
      const [sociosRes, pagosRes] = await Promise.all([
        axios.get("https://socios.kolpingchile.cl/backend/api/socios"),
        axios.get("https://socios.kolpingchile.cl/backend/api/pagos")
      ]);

      const sociosConPagos = sociosRes.data.map((socio) => ({
        ...socio,
        tipo: getTipo(tiposSocio, socio.tipo_socio),
        pagos: pagosRes.data[socio.rut] || {}
      }));

      setSocios(sociosConPagos);
    } catch (error) {
      console.error("Error al obtener socios o pagos", error);
    }
  };

  const fetchMontos = async () => {
    try {
      const res = await axios.get("https://socios.kolpingchile.cl/backend/api/montos");
      const mapa = {};
      res.data.forEach((item) => {
        mapa[item.id] = item.monto;
      });
      setMontosPorTipo(mapa);
      console.log("Montos por tipo obtenidos:", mapa);
    } catch (err) {
      console.error("Error al obtener montos por tipo:", err);
    }
  };

  const fetchMontosEspeciales = async () => {
    try {
      const res = await axios.get("https://socios.kolpingchile.cl/backend/api/montos_esp");
      const mapa = {};
      res.data.forEach((item) => {
        mapa[item.id] = item.monto;
      });
      setMontosEspeciales(mapa);
      console.log("Montos especiales obtenidos:", mapa);
    } catch (err) {
      console.error("Error al obtener montos especiales:", err);
    }
  };


  const fetchTiposSocio = async () => {
    try {
      const { data } = await axios.get("https://socios.kolpingchile.cl/backend/api/tipos");
      setTiposSocio(data);
    } catch (error) {
      console.error("Error al obtener tipos de socio:", error);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "1": return "success";
      case "2": return "secondary";
      case "4": return "dark";
      case "3": return "warning";
      case "5": return "info";
      default: return "light";
    }
  };

  const getUltimoMesPagado = (pagos, status) => {
    if (status === "Exento") return "EXENTO";

    if (!pagos || typeof pagos !== "object") return "N/A";
    const mesesPagados = Object.keys(pagos).filter(mes => pagos[mes]?.pagado);
    return mesesPagados.length ? mesesPagados[mesesPagados.length - 1] : "N/A";
  };

  const handleEdit = async (socio) => {
    try {
      const [pagosRes, cuotasRes] = await Promise.all([
        axios.get(`https://socios.kolpingchile.cl/backend/api/pagos/${socio.rut}`),
        axios.get(`https://socios.kolpingchile.cl/backend/api/cuotas_especiales/${socio.rut}`)
      ]);
      
      const pagosDelSocio = pagosRes.data;
      const cuotasEspeciales = cuotasRes.data;
      const añoActual = new Date().getFullYear();

      const pagosActualizados = mesesDelAnio.reduce((acc, mes) => {
        const pago = pagosDelSocio["pagos"].find(p => p.mes.toLowerCase() === mes.toLowerCase() && p.año === añoActual);
        const clave = `${mes} ${añoActual}`;
        acc[clave] = pago ? Boolean(pago.pagado) : false;
        return acc;
      }, {});

      const internacional = cuotasEspeciales.some(c => c.tipo === "internacional" && c.pagado === 1 && c.año === añoActual);

      setSelectedSocio(socio);
      setPagos(pagosActualizados);
      setInternacional(internacional);
      setShowModal(true);
    } catch (error) {
      console.error("Error al obtener pagos del socio", error);
    }
  };

  const handlePagoChange = (mes) => {
    setPagos(prev => ({
      ...prev,
      [mes]: !prev[mes]
    }));
  };

  const handleSave = async () => {
    try {
      const tipoId = selectedSocio.tipo_socio;
      const montoPorDefecto = montosPorTipo[tipoId] || 0;

      const esExento = selectedSocio.status === "Exento";

      const pagosConMonto = Object.keys(pagos).reduce((acc, mes) => {
        acc[mes] = { pagado: pagos[mes], monto: pagos[mes] ? (esExento ? 0 : montoPorDefecto) : 0 };
        return acc;
      }, {});

      if (Internacional) {
        await axios.put(`https://socios.kolpingchile.cl/backend/api/cuotas_especiales/${selectedSocio.rut}`, {
          tipo: "internacional",
          pagado: 1,
          año: new Date().getFullYear()
        });
      }

      await axios.put(`https://socios.kolpingchile.cl/backend/api/pagos/${selectedSocio.rut}`, { pagos: pagosConMonto });
      fetchSocios();
      setShowModal(false);
    } catch (error) {
      console.error("Error al actualizar pagos", error);
    }
  };

  const handleSaveCI = async () => {
    try {
      await axios.put(
        `https://socios.kolpingchile.cl/backend/api/cuotas_especiales/${ciRut}`,
        {
          tipo: "incorporacion",
          pagado: 1,
          año: new Date().getFullYear()
        }
      );

      setShowModalCI(false);

    } catch (error) {
      console.error("Error al guardar CI", error);
    }
  };



  const guardarMontos = async () => {
    try {
      await axios.put("https://socios.kolpingchile.cl/backend/api/montos", montosPorTipo);
      await axios.put("https://socios.kolpingchile.cl/backend/api/montos_esp", montosEspeciales);
      console.log("Montos por tipo guardados:", montosPorTipo);
      console.log("Montos especiales guardados:", montosEspeciales);
      alert("Montos guardados correctamente.");
      setShowModalMontos(false);
    } catch (error) {
      console.error("Error al guardar montos por tipo:", error);
      alert("Hubo un error al guardar los montos.");
    }
  };
  const getStatusNombre = (status) => {
    switch (status) {
      case "1": return "ACTIVO";
      case "2": return "INACTIVO";
      case "3": return "SUSPENDIDO";
      case "4": return "FALLECIDO";
      case "5": return "EXENTO";
      default: return "DESCONOCIDO";
    }
  };

  const exportarExcel = () => {
    const datos = sortedSocios.map(s => ({
      "N° Socio": s.n_socio,
      "RUT": s.rut,
      "Nombre": `${s.nombre} ${s.apellido}`,
      "Tipo": s.tipo,
      "Status": getStatusNombre(s.status),
      "Último Mes Pagado": getUltimoMesPagado(s.pagos, s.status)
    }));
    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Socios");
    XLSX.writeFile(wb, "socios-contabilidad.xlsx");
  };

  const exportarPDF = () => {
    const doc = new jsPDF();

    const columns = ["N° Socio", "RUT", "Nombre", "Tipo", "Familia", "Status", "Último Mes Pagado"];

    const data = sortedSocios.map(socio => [
      socio.n_socio,
      socio.rut,
      `${socio.nombre} ${socio.apellido}`,
      socio.tipo,
      socio.nombreFamilia,
      getStatusNombre(socio.status),
      getUltimoMesPagado(socio.pagos, socio.status)
    ]);

    const options = {
      startY: 20,
      headStyles: { fillColor: [41, 128, 185] },
      styles: { overflow: 'linebreak' },
      columnStyles: { 0: { halign: 'center' } }
    };

    autoTable(doc, {
      head: [columns],
      body: data,
      ...options
    });
    doc.save("socios-contabilidad.pdf");
  };

  const sortedSocios = socios.filter(s => {
    const coincideBusqueda = `${s.nombre} ${s.apellido} ${s.rut} ${s.n_socio}`.toLowerCase().includes(busqueda.toLowerCase());
    const coincideTipo = tipoFiltro === "todos" || String(s.tipo_socio) === tipoFiltro;
    const coincideFamilia =
      familiaFiltro === "" || s.nombreFamilia === familiaFiltro;
    const esVisible =
      s.status === "1" || s.status === "5";

    return coincideBusqueda && coincideTipo && coincideFamilia && esVisible;
  });

  const totalPages = Math.ceil(sortedSocios.length / rowsPerPage);
  const sociosPaginados = sortedSocios.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);


  const getVisiblePageNumbers = () => {
    const totalPages = Math.ceil(sortedSocios.length / rowsPerPage);
    const visiblePages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - maxVisiblePages + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }

    return visiblePages;
  };
  const indexOfLastSocio = currentPage * rowsPerPage;
  const indexOfFirstSocio = indexOfLastSocio - rowsPerPage;
  const totalSocios = sortedSocios.length;
  const rutConGuion = (rut) => {
    if (!rut) return "";

    // Quitar puntos y guion
    let rutLimpio = rut.replace(/\./g, "").replace(/-/g, "");

    // Separar cuerpo y dígito verificador
    const cuerpo = rutLimpio.slice(0, -1);
    const dv = rutLimpio.slice(-1);

    // Formatear con puntos cada 3 dígitos (de derecha a izquierda)
    let cuerpoFormateado = "";
    let contador = 0;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      cuerpoFormateado = cuerpo[i] + cuerpoFormateado;
      contador++;
      if (contador % 3 === 0 && i !== 0) {
        cuerpoFormateado = "." + cuerpoFormateado;
      }
    }

    return `${cuerpoFormateado}-${dv.toUpperCase()}`; // Retornar con guion y DV en mayúscula
  };


  return (
    <div className="container-fluid mt-5 px-2">
      <Card className="shadow p-2 p-md-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
          <h2 className="d-flex mt-2 mx-4">Contabilidad de Socios</h2>
          <div className="d-flex flex-wrap gap-2 mx-4">
            <RoleGate allowedRoles={["Administrador", "Contador"]}>
              <Button
                className="btn btn-primary btn-sm"
                onClick={async () => {
                  await fetchMontos();
                  await fetchMontosEspeciales();
                  setShowModalMontos(true);
                }}>
                Monto Cuotas
              </Button>

              <Button className="btn btn-info btn-sm" onClick={() => setShowModalCI(true)}>
                Ingresar Cuota de Incorporación
              </Button>

              <Link style={{ color: "white", textWeight: "bold" }} to="/reportes" className="btn btn-warning px-3 ">Reportes</Link>
            
            </RoleGate>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-4 align-items-stretch align-items-md-end gap-2">
          <TextField label="BUSCAR POR N° SOCIO, RUT O NOMBRE" fullWidth value={busqueda} onChange={e => setBusqueda(e.target.value)} size="small" />
          <select className="form-control form-control-sm" value={tipoFiltro} onChange={e => setTipoFiltro(e.target.value)}>
            <option value="todos">Todos los tipos</option>
            {tiposSocio.map(t => (
              <option key={t.id} value={t.id}>{t.nombre}</option>
            ))}
          </select>

          <select
            className="form-select form-select-sm"
            value={familiaFiltro}
            onChange={(e) => setFamiliaFiltro(e.target.value)}
          >
            <option value="">Todas las familias</option>
            {[...new Set(socios.map(s => s.nombreFamilia))]
              .filter(f => f !== "Desconocido")
              .sort((a, b) => {
                const valorA = a ?? "";
                const valorB = b ?? "";
                return valorA.localeCompare(valorB, "es", { sensitivity: "base" });
              })

              .map((familia, idx) => (
                <option key={idx} value={familia}>{familia}</option>
              ))}

          </select>
          <div className="d-flex justify-content-sm-center gap-2">
            <Button title="Exportar a Excel" className="btn btn-success btn-sm" onClick={exportarExcel}><FontAwesomeIcon icon={faFileExcel} size="lg" /></Button>
            <Button title="Exportar a PDF" className="btn btn-danger btn-sm" onClick={exportarPDF}><FontAwesomeIcon icon={faFilePdf} size="lg" /></Button>
          </div>
        </div>
        <div className="mb-4 d-flex justify-content-center flex-column flex-sm-row gap-2">
          <label className="mr-2">N° de filas: </label>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
            className="flex text-center border rounded px-2 py-1 form-select-md"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        <p className="text-center text-muted small">
          Mostrando {indexOfFirstSocio + 1}–{Math.min(indexOfLastSocio, totalSocios)} de {totalSocios}        </p>

        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-light">
              <tr>
                <th>N° Socio</th>
                <th>RUT</th>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Familia</th>
                <th>Status</th>
                <th>Último mes pagado</th>
                <RoleGate allowedRoles={["Administrador", "Contador"]}>
                  <th>Acciones</th>
                </RoleGate>
              </tr>
            </thead>
            <tbody>
              {sociosPaginados.map(socio => {
                const ultimoMes = getUltimoMesPagado(socio.pagos);
                const esMoroso =
                  socio.status === "1" &&
                  (ultimoMes === "N/A" || !ultimoMes.includes(new Date().getFullYear()));
                return (
                  <tr key={socio.rut} className={esMoroso ? "table-danger" : ""}>
                    <td>{socio.n_socio}</td>
                    <td>{rutConGuion(socio.rut)}</td>
                    <td>{socio.nombre} {socio.apellido}</td>


                    <td>
                      <span className={`badge bg-${String(socio.tipo_socio) === "1" ? "success" : String(socio.tipo_socio) === "2" ? "secondary" : String(socio.tipo_socio) === "3" ? "info" : "warning"}`}>
                        {String(socio.tipo_socio) === "1" ? "ACTIVO" : String(socio.tipo_socio) === "2" ? "PASIVO" : String(socio.tipo_socio) === "3" ? "COOPERADOR" : "ESTUDIANTE"}
                      </span>
                    </td>


                    <td>{socio.nombreFamilia}</td>
                    <td style={{ fontSize: "small", width: "1%" }}>
                      <span className={`badge bg-${String(socio.status) === "1" ? "success" : String(socio.status) === "2" ? "danger" : String(socio.status) === "3" ? "warning" : String(socio.status) === "4" ? "dark" : "info"}`}>
                        {String(socio.status) === "1" ? "ACTIVO" : String(socio.status) === "2" ? "INACTIVO" : String(socio.status) === "3" ? "SUPENDIDO" : String(socio.status) === "4" ? "FALLECIDO" : "EXENTO"}
                      </span>
                    </td>
                    <td>{ultimoMes.toUpperCase()}</td>
                    <RoleGate allowedRoles={["Administrador", "Contador"]}>
                      <td><button className="btn btn-sm me-2" title="Editar" onClick={() => handleEdit(socio)}><FontAwesomeIcon icon={faPenToSquare} /></button></td>
                    </RoleGate>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <p className="text-center text-muted small">
          Mostrando {indexOfFirstSocio + 1}–{Math.min(indexOfLastSocio, totalSocios)} de {totalSocios}        </p>
        <div className="d-flex justify-content-center mt-3">
          <nav>
            <ul className="pagination pagination-sm">

              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                  Anterior
                </button>
              </li>

              {getVisiblePageNumbers().map((number) => (
                <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(number)}>
                    {number}
                  </button>
                </li>
              ))}

              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                  Siguiente
                </button>
              </li>

            </ul>
          </nav>
        </div>
      </Card>

      {/* Modal de pagos */}
      {selectedSocio && showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content" >
              <div className="modal-header">
                <h5 className="modal-title">Editar Pagos - {selectedSocio.nombre} {selectedSocio.apellido}</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
                  <label>Internacional</label>
                  <Switch
                    checked={!!Internacional}
                    onChange={() => setInternacional(!Internacional)}
                    color="primary"
                  />
                </div>

                <div hidden={selectedSocio.status === "5"}>
                  <hr />
                  {mesesDelAnio.map((mes) => {
                    const clave = `${mes} ${new Date().getFullYear()}`;
                    return (
                      <div key={clave} className="d-flex justify-content-between align-items-center mb-2" >
                        <label >{clave}</label>
                        <Switch
                          checked={!!pagos[clave]}
                          onChange={() => handlePagoChange(clave)}
                          disabled={selectedSocio.status === "5"}
                          color="primary"
                        />
                      </div>
                    );
                  })}
                </div>

              </div>
              <div className="modal-footer">
                <Button className="btn btn-success" onClick={handleSave}>Guardar</Button>
                <Button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal de montos por tipo de socio */}
      {showModalMontos && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Monto de Cuotas</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModalMontos(false)}
                ></button>
              </div>

              <div className="modal-body">
                {/* 🔹 Cuota de Incorporación */}
                <div className="mb-3">
                  <label className="form-label">CUOTA DE INCORPORACIÓN</label>
                  <TextField
                    type="number"
                    value={montosEspeciales[5] ?? "0"}
                    onChange={(e) =>
                      setMontosEspeciales((prev) => ({
                        ...prev,
                        [5]: Number(e.target.value),
                      }))
                    }
                    fullWidth
                    slotProps={{
                      htmlInput: {
                        step: 100,
                        min: 0,
                      },
                    }}
                  />
                </div>

                {/* 🔹 Cuota Internacional */}
                <div className="mb-3">
                  <label className="form-label">CUOTA INTERNACIONAL</label>
                  <TextField
                    type="number"
                    value={montosEspeciales[6] ?? "1"}
                    onChange={(e) =>
                      setMontosEspeciales((prev) => ({
                        ...prev,
                        [6]: Number(e.target.value),
                      }))
                    }
                    fullWidth
                    slotProps={{
                      htmlInput: {
                        step: 100,
                        min: 0,
                      },
                    }}
                  />
                </div>
                <hr />
                Cuota Mensual por Tipo de Socio:
                <hr />

                {/* 🔹 Cuotas por tipo de socio */}
                {tiposSocio.map((tipo) => (
                  <div key={tipo.id} className="mb-3">
                    <label className="form-label">{tipo.nombre}</label>
                    <TextField
                      type="number"
                      value={montosPorTipo[tipo.id] ?? "0"}
                      onChange={(e) =>
                        setMontosPorTipo((prev) => ({
                          ...prev,
                          [tipo.id]: Number(e.target.value),
                        }))
                      }
                      fullWidth
                      slotProps={{
                        htmlInput: {
                          step: 100,
                          min: 0,
                        },
                      }}
                    />
                  </div>
                ))}
              </div>

              <div className="modal-footer">
                <Button className="btn btn-success" onClick={guardarMontos}>
                  Guardar
                </Button>
                <Button
                  className="btn btn-secondary"
                  onClick={() => setShowModalMontos(false)}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModalCI && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Ingresar Cuota de Incorporación</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModalCI(false)}
                ></button>
              </div>

              <div className="modal-body">
                <label>RUT:</label>
                <TextField
                  type="text"
                  value={ciRut}
                  onChange={(e) => setCiRut(e.target.value)}
                  fullWidth
                />
                <Button className="btn btn-success mt-3" onClick={handleSaveCI}>
                  Registrar
                </Button>

              </div>

              <div className="modal-footer">
                <Button
                  className="btn btn-secondary"
                  onClick={() => setShowModalCI(false)}
                >
                  Cerrar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Contabilidad;
